module.exports = __webpack_public_path__ + "img/Hero Image 2.ae2cd4d6.jpeg";